export enum URLEndpoints{
    //auth endpoints
    ExamRegistrationLogin = 'ExamMaster/ExamRegistrationLogin',
    ReadExaminationForExternalApply= 'ExamMaster/ReadExaminationForExternalApply',
    ReadPaperDetailsForExternalExamApply='ExamMaster/ReadPaperDetailsForExternalExamApply',
    UpdateExternalExamRegistration='ExamMaster/UpdateExternalExamRegistration',
    ReadStudentCondonationAllSemDetails='ExamMaster/ReadStudentCondonationAllSemDetails',
    ReadStudentEnrollmentDetails='ExamMaster/ReadStudentEnrollmentDetails',
    ReadStudentAddressDetails='ExamMaster/ReadStudentAddressDetails',
    UpdateStudentAddress='ExamMaster/UpdateStudentAddress'
}